module.exports = __webpack_public_path__ + "img/screenshot-step4-teacher.2928749f.png";